/// <amd-module name="Wit/Common/WitSettingsViews/Components/FieldSettingsConstants" />
import { CoreFieldRefNames, FieldType } from "Wit/Common/Generated/Constants";

export namespace FieldSettingsConstants {
    export const supportedFieldTypes = new Set([
        FieldType.String,
        FieldType.Integer,
        FieldType.DateTime,
        FieldType.PlainText,
        FieldType.TreePath,
        FieldType.Double,
        FieldType.Boolean
    ]);

    export const notSupportedFieldReferenceNames = new Set([
        CoreFieldRefNames.Id.toLowerCase(),
        CoreFieldRefNames.Title.toLowerCase(),
        CoreFieldRefNames.AssignedTo.toLowerCase(),
        CoreFieldRefNames.Tags.toLowerCase(),
        CoreFieldRefNames.AreaId.toLowerCase(),
        CoreFieldRefNames.IterationId.toLowerCase(),
        CoreFieldRefNames.Rev.toLowerCase(),
        CoreFieldRefNames.RevisedDate.toLowerCase(),
        CoreFieldRefNames.NodeName.toLowerCase(),
        CoreFieldRefNames.TeamProject.toLowerCase(),
        CoreFieldRefNames.Watermark.toLowerCase(),
        CoreFieldRefNames.ExternalLinkCount.toLowerCase(),
        CoreFieldRefNames.HyperLinkCount.toLowerCase(),
        CoreFieldRefNames.RelatedLinkCount.toLowerCase(),
        CoreFieldRefNames.AttachedFileCount.toLowerCase(),
        CoreFieldRefNames.AuthorizedAs.toLowerCase(),
        CoreFieldRefNames.AuthorizedDate.toLowerCase()
    ]);
}
